import SubstrateSearchRequest from '../../../data/schema/SubstrateSearchRequest';
import ExecuteSearchJsonRequest from 'owa-service/lib/contract/ExecuteSearchJsonRequest';
import getTimeZone from './getTimeZone';
import createEntityRequests from './createEntityRequests';
import SubstrateSearchScenario from '../../../data/schema/SubstrateSearchScenario';

/**
 * Converts ExecuteSearch request to 3S query request.
 */
export default function executeSearchRequestToSubstrateRequest(params: {
    request: ExecuteSearchJsonRequest;
    cvid: string;
    queryIncludesPeopleSuggestion: boolean;
    pageNumber: number;
    substrateSearchScenario: SubstrateSearchScenario;
    actionSource: string;
}): SubstrateSearchRequest {
    const {
        request,
        cvid,
        queryIncludesPeopleSuggestion,
        pageNumber,
        substrateSearchScenario,
        actionSource,
    } = params;

    const substrateSearchRequest: SubstrateSearchRequest = {
        Cvid: cvid,
        Scenario: { Name: substrateSearchScenario },
        TimeZone: getTimeZone(request.Header),
        TextDecorations: 'Off',
        EntityRequests: createEntityRequests(
            request,
            queryIncludesPeopleSuggestion,
            pageNumber,
            actionSource
        ),
    };

    return substrateSearchRequest;
}
